import styled from '@emotion/styled'
import { css } from '@emotion/react'

const ImgStyles = () => css`
  width: 100%;
`

export const Image = styled('img')(ImgStyles)
